<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useDeviceStore } from "@/entities/device/model";
import { useEvaluationStore } from "@/entities/evaluation/model";
import { HandedDevice } from "@/entities/evaluation/ui";
import { useB2bPrice } from "@/features/b2b-price/model";
import { BuyoutRequestForm } from "@/features/request-buyout-offer/ui";
import { StepBackButton } from "@/features/step-back/ui";
import { useGlobalStore } from "@/shared/model";
import { UiStepLayout, startViewTransition } from "@/shared/ui";

const { t } = useI18n({ useScope: "global" });
const globalStore = useGlobalStore();
const deviceStore = useDeviceStore();
const evaluationStore = useEvaluationStore();
const { b2bPrice } = useB2bPrice();

// The store is reset inside the transition, so the old snapshot keeps the filled screen
function editDevice(): void {
    void startViewTransition(() => {
        evaluationStore.reset();
        globalStore.resetStep();
    });
}

function onContactsFilled(): void {
    void globalStore.switchStep("uploadDevicesList");
}
</script>

<template>
    <UiStepLayout>
        <template #header>
            <h2 class="title">{{ t("leaveContacts.title") }}</h2>
        </template>

        <HandedDevice :chain="deviceStore.chain" :price="b2bPrice" with-state @edit="editDevice">
            <template #note>{{ t("leaveContacts.priceNote") }}</template>
        </HandedDevice>

        <BuyoutRequestForm @submit="onContactsFilled">
            <template #back>
                <StepBackButton />
            </template>
        </BuyoutRequestForm>
    </UiStepLayout>
</template>

<style scoped>
.title {
    margin: 0;
    font-size: calc(var(--custom-font-size) * 1.429);
    font-weight: 700;
    line-height: 1.2;
}
</style>
